import { Button, Form, Modal } from "react-bootstrap";

const ReportModal = ({
  show,
  onHide,
  t,
  reportReason,
  setReportReason,
  reportDetails,
  setReportDetails,
  submitReport,
  isReporting,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-dark">{t("reportPost")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="text-dark">
              {t("reasonForReporting")}
            </Form.Label>
            <Form.Control
              as="select"
              value={reportReason}
              onChange={(e) => setReportReason(e.target.value)}
            >
              <option value="">{t("selectReason")}</option>
              <option value="spam">{t("spam")}</option>
              <option value="inappropriatecontent">
                {t("inappropriateContent")}
              </option>
              <option value="harassment">{t("harassment")}</option>
              <option value="other">{t("other")}</option>
            </Form.Control>
          </Form.Group>

          {reportReason === "other" && (
            <Form.Group>
              <Form.Label className="text-dark">
                {t("additionalDetails")}
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder={t("describeIssue")}
                value={reportDetails}
                onChange={(e) => setReportDetails(e.target.value)}
              />
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("cancel")}
        </Button>
        <Button variant="danger" onClick={submitReport} disabled={isReporting}>
          {isReporting ? t("reporting") : t("submitReport")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportModal;
